import React, { useEffect, useState} from 'react';
import LandingHeader from "./landing-header";
import LandingBanner from "./landing-banner";
import LandingFeatures from "./landing-features";

import LandingBackground from '../../assets/Landing_background.png';
import LandingImg from "../../assets/Landing_img.jpg";
import LandingImgBm from "../../assets/LandingImgBm.jpg";
import AppVersion from "../version";
import {ReactComponent as UnhappyError} from "../../assets/unhappyerror.svg";
import {_getSystemAvailable, _getScheduledMaintenance, _getBanners} from "../../store/system/service";
import {_getPolicy} from "../../store/policy/service";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Carousel from "../carousel/carousel";

import "./landing.css"

const getImage = site =>{
    let result = null
    switch (site){
        case 'bm':
            result = LandingImgBm
            break
        case 'mla':
            // result = LandingImgMLA
            // break
        case 'gnm':
        default:
            result = LandingImg

    }
    return result
}

const isMobile = () => {
    if (navigator.userAgent.match(/Android/i)
         || navigator.userAgent.match(/webOS/i)
         || navigator.userAgent.match(/iPhone/i)
         || navigator.userAgent.match(/iPad/i)
         || navigator.userAgent.match(/iPod/i)
         || navigator.userAgent.match(/BlackBerry/i)
         || navigator.userAgent.match(/Windows Phone/i)) {
            return true;
         } else {
            return false;
    }
}

const Landing = (props) => {
    const [scheduledMaintenance, setScheduledMaintenance] = useState(null);
    const [bannerList, setBannerList] = useState(null);
    const hasError = !props.systemAvailable;

    const [currentScrollPosition, setCurrentScrollPosition] = useState(0);

    useEffect(() => {
        props.getScheduledMaintenance(props?.country).then(resp => {
            if (Object.keys(resp.data).length) {
                setScheduledMaintenance(resp.data);
            }
        });

        props.getBanners(props?.policy?.productType).then(resp => {
            if (Object.keys(resp.data).length) {
                setBannerList(resp.data);
            }
        });
    },[]);

    useEffect(() => {
        if(!props.systemAvailable || scheduledMaintenance) {
            adjustUI()
        }
    });

    const isLandingPage = () => {
        if(document.getElementById("startQuoteBtn")) {
            return true;
        } else {
            return false;
        }
    }

    useEffect(() => {
        function onScroll() {
            setCurrentScrollPosition(document.documentElement.scrollTop);
            if(isLandingPage()) {
                if(bannerList) {
                    if(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
                        document.getElementById("header").style.position = "relative";
                        if(currentScrollPosition > 208) {
                            document.getElementById("header").style.position = "fixed";
                            document.getElementById("header").style.top = "0";
                        } else if(currentScrollPosition < 1) {
                            document.getElementById("header").style.position = "fixed";
                        } else {
                            document.getElementById("header").style.top = "initial";
                        }
                    } else {
                       if(currentScrollPosition > 80){
                            document.getElementById("header").style.position = "fixed";
                            document.getElementById("header").style.top = "0";
                        }else{
                            document.getElementById("header").style.top = "initial";
                        }
                    }
                }
            }
        }

        return window.document.addEventListener("scroll", onScroll);
    }, [currentScrollPosition]);

    const ScheduledMaintenance = () => {
        return (
            <div id="scheduledMaintenance">
                <span className="ScheduledMaintenanceText">
                    {scheduledMaintenance.message + " " + scheduledMaintenance.longMessage}
                    You may also refer to upcoming scheduled maintenance <a className='error-notification-link' href='https://www.qbe.com/sg/qnect/scheduled-maintenance' target="_blank" rel="noreferrer">here</a>.
                    Please accept our sincerest apologies for any inconvenience caused.
                </span>
            </div>
        )
    }

    const SystemUnavailableError = () => {
        return (
            <>
                <div id="systemUnavailable">
                    <UnhappyError className="ErrorImg"  alt=""/>
                    <span className="ErrorText">Sorry, our system is currently unavailable. Please try again later.</span>
                </div>
            </>
        )
    }

    const TopErrorContainer = () => {
        return (
                <div className="TopErrorContainer">
                    {hasError && <SystemUnavailableError/>}
                    {scheduledMaintenance && <ScheduledMaintenance/>}
                </div>
        )
    }

    const adjustUI = () => {
        document.getElementsByClassName("LandingFrameStyle")[0].style.minHeight = "1450px";
        document.getElementsByClassName("LandingCardStyle")[0].style.marginTop = "100px";
        if(isMobile()) {
            if(hasError && (scheduledMaintenance != null)) {
                document.getElementsByClassName("LandingCardStyle")[0].style.marginTop = "245px";
            } else if(hasError) {
                document.getElementsByClassName("LandingCardStyle")[0].style.marginTop = "100px";
            } else if(scheduledMaintenance) {
                document.getElementsByClassName("LandingCardStyle")[0].style.marginTop = "180px";
            }
        }
    }

    return (
        <>
            { bannerList && <Carousel bannerList={bannerList}/>}
            <div>{scheduledMaintenance || hasError ? <TopErrorContainer/> : ""}</div>
            <div className="LandingFrameStyle">
                <div className="LandingCardStyle">
                    <img className="LandingBackgroundImgStyle" src={LandingBackground} />
                    <LandingHeader site={props.site}/>
                    <div className="LandingImgDivStyle">
                        <React.Fragment>
                            <img className="LandingBmImgStyle" src={getImage(props.site)}  />
                            <div className="LandingImgBorderStyle" />
                        </React.Fragment>
                    </div>
                    <LandingBanner site={props.site}/>
                    <LandingFeatures/>
                    <AppVersion landing/>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = state => {
    return {
        systemAvailable: _getSystemAvailable(state),
        policy: _getPolicy(state),
    };
}

const mapDispatchToProps = {
    getScheduledMaintenance: _getScheduledMaintenance,
    getBanners: _getBanners
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Landing));
